<template>
  <div
    class="match-info"
    :class="`match-sport-${matchSportId}`">
    <div
      class="vertical-line"
      :class="`sport-color-${matchSportId}`"
    />
    <match-info-teams :id-match="idMatch" />
    <div
      class="match-info-result"
      :class="`match-sport-${matchSportId}`">
      <match-info-results
        :id-match="idMatch"
        :id-sport="matchSportId"
      />
    </div>
  </div>
</template>

<script>
import MatchInfoResults from './MatchInfoResults.vue';
import MatchInfoTeams from './MatchInfoTeams.vue';

export default {
  name: 'MatchInfo',
  components: {
    MatchInfoResults,
    MatchInfoTeams,
  },
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
  },
  computed: {
    matchSportId() {
      return this.$store.getters.getMatchIdSport(this.idMatch);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-info {
  height: 100%;

  // Tennis
  &.match-sport-5 {
    .match-info-teams {
      margin-right: $match-results-width + $match-points-width;
    }
  }
}

.vertical-line {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: $match-vertical-line-width;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: 1;
}

.match-info-result {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: $match-results-width;

  &.match-sport-5 {
    right: $match-points-width;
  }
}
</style>
